import { Box, Divider, Skeleton, Stack, Typography } from '@mui/material';

interface CountActionCardProps {
  countElements: { value?: number | null; label: string }[];
  isLoading?: boolean;
  children?: React.ReactNode;
}

const countGridSx = {
  display: 'grid',
  gridAutoColumns: '1fr',
  gridAutoFlow: 'column',
  columnGap: 4,
};

const countValueSx = {
  lineHeight: 1.2,
  m: 0,
};

const countLabelSx = {
  color: 'text.secondary',
  fontSize: '0.75rem',
  lineHeight: 1.33,
  m: 0,
};

export const CountActionCard: React.FC<CountActionCardProps> = ({
  countElements,
  isLoading = false,
  children,
}) => (
  <Stack spacing={2}>
    <Box sx={countGridSx}>
      {countElements.map(({ value, label }, index) => (
        <Stack key={index} spacing={0.25}>
          <Typography variant="h6" sx={countValueSx}>
            {isLoading ? <Skeleton width={20} height={24} /> : value ?? 0}
          </Typography>
          <Typography sx={countLabelSx}>{label}</Typography>
        </Stack>
      ))}
    </Box>
    {children != null && (
      <>
        <Divider />
        {children}
      </>
    )}
  </Stack>
);

export const CountActionCardSkeleton: React.FC<{
  countLabels: string[];
  children?: React.ReactNode;
}> = ({ countLabels, children }) => (
  <CountActionCard
    countElements={countLabels.map(label => ({ label }))}
    isLoading={true}
  >
    {children}
  </CountActionCard>
);
